import type { UserInputValues } from '@tectonics/prs/user-input-values';
import type { OutgoingPayment } from '@tectonics/prs/outgoing-payment';

export function customerOutgoingPaymentMapper(userInputValues: UserInputValues): Partial<OutgoingPayment> {
  return {
    name: userInputValues['customerName'] as string,
    email: userInputValues['customerEmail'] as string,
    ...(userInputValues['saveCardOneClick']
      ? { save_card_oneclick: userInputValues['saveCardOneClick'] as boolean }
      : {}
    ),
  };
}
